import { Box, Paper, Typography } from "@mui/material";
import { ReactNode } from "react";
import { SectionLabel } from "../general/SectionLabel.tsx";
import { card } from "./PortfolioSection.tsx";

/**
 * A card of the settlements page: its label, what it shows in a sentence or
 * two, and under them its figures or its chart. A control that changes what
 * the card shows stands beside the label.
 */
export const SettlementPanel = ({
  id,
  label,
  description,
  control,
  children,
}: {
  // where the navigation scrolls to the card itself
  id?: string;
  label: string;
  description: string;
  control?: ReactNode;
  children: ReactNode;
}) => (
  <Paper id={id} component="section" variant="outlined" sx={card}>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 1.5,
      }}
    >
      <SectionLabel component="h3">{label}</SectionLabel>
      {control}
    </Box>
    <Typography
      variant="body2"
      sx={{ mt: 0.5, color: "text.secondary", maxWidth: "124ch" }}
    >
      {description}
    </Typography>
    {children}
  </Paper>
);
